import { NetworkStatus } from "@apollo/client";
import { isEqual } from "lodash";

import { useAppContext } from "@/app/context";
import { useFewAccountDetailsQuery } from "@/app/types/generated/graphql";

export const useAccountInfo = (args?: { skipQuery?: boolean }) => {
  const { userAccountInfo, setUserAccountInfo } = useAppContext();
  const { data, loading, error, networkStatus } = useFewAccountDetailsQuery({
    skip: args?.skipQuery,
    onCompleted: (data) => {
      if (!data?.account || !userAccountInfo) return;

      const updatedAccountInfo = {
        ...userAccountInfo,
        firstName: data.account.firstName,
        lastName: data.account.lastName,
        status: data.account.status,
        linkedRegistries: data.account.linkedRegistries,
      };

      if (!isEqual(updatedAccountInfo, userAccountInfo)) {
        setUserAccountInfo(updatedAccountInfo);
      }
    },
  });

  if (error) {
    throw error;
  }

  return {
    loading: loading,
    dataReady: !loading && networkStatus === NetworkStatus.ready && !!data,
    ...data?.account,
  };
};
